/* eslint-disable @typescript-eslint/naming-convention */
declare global {
  interface Window {
    FLS_REACT_APP_API_BASE_URL: string | undefined;
    REACT_APP_API_BASE_URL: string | undefined;
  }
}

const runtimeApiUrl =
  typeof window === 'undefined' ? undefined : window.REACT_APP_API_BASE_URL || window.FLS_REACT_APP_API_BASE_URL;

export const API_URL = runtimeApiUrl || (import.meta.env.VITE_REACT_APP_API_BASE_URL as string);
